<template>
    <SettingsCompanies :client="client" @updated="onSetupComplete"/>
</template>
<script>
    import SettingsCompanies from '@/pages/client/Settings/Companies'

    export default {
        props: ['client', 'setupStatus'],
        components: {SettingsCompanies},
        data() {
            return {}
        },
        methods: {
            onSetupComplete() {
                this.$store.dispatch('START_LOADING')
                this.$api.post(`/clients/${this.client.id}/setup-status`, {step: 'companies'}).then(resp => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('refreshClient')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$bus.showError(errors.__all__)
                })
            },
        },
    }
    </script>
